import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import { CardContent, CardMedia, Typography } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  }
}));

function CardEntry({ title, year, language, category, genre, averagerating, channel, ratingsBy }) {
  const subTitleTxt = [category, language, year, genre].filter((e) => e !== undefined).join(' - ');
  const classes = useStyles();
  return <Card>
    <CardMedia className={classes.media} image="https://picsum.photos/450/200?blur=2"></CardMedia>  
    <CardContent>
      <Typography variant="h4" component="h2" color="textSecondary">{title}</Typography>
      <Typography color="textSecondary" variant="subtitle1">
        {subTitleTxt}
      </Typography>
      <Typography variant="body2" component="p" color="textSecondary" style={{ marginBottom: 10 }}>
        Average Rating: {averagerating} <br />
        Watch On: {channel}
      </Typography>
      <Typography variant="body1" component="p" color="textSecondary">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quo ea illum esse ad eius qui ratione reprehenderit tempore soluta voluptatum eum iure velit, iste ullam eos aliquam molestias error deserunt!
      </Typography>
      <Typography variant="caption" component="p" style={{marginTop:10}}>
        Rated By: {ratingsBy}
      </Typography>
    </CardContent>
  </Card>;
}

export default CardEntry;